/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbButtonModule,
  NbCardModule,
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbFilterInputDirective,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbMenuModule,
  NbSidebarModule,
  NbThemeModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModulesComponent } from './modules/modules.component';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { NbAuthJWTInterceptor, NbAuthModule, NbAuthService, NbOAuth2AuthStrategy, NbPasswordAuthStrategy } from '@nebular/auth';
import { ConfirmationDialogComponent } from './dialog/confirmation-dialog/confirmation-dialog.component';
import { SessionTimeoutModalComponent } from './shared/session-timeout-modal/session-timeout-modal.component';
import { BnNgIdleService } from 'bn-ng-idle';
import { MsalGuard, MsalBroadcastService, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication, InteractionType, Configuration, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { msalConfig } from './auth/azureConfig/auth-config';
import { AuthInterceptor } from './auth/auth-interceptor';
import { LocalStorageService } from './shared/localStorage.service';
import { SessionTokenTimeoutService } from './shared/session-timeout.service';
import { SessionTimerInitializer } from './session-timer-initializer';
import { msalEnvConfig } from './auth/azureConfig/auth-env-config';
import { msalProdConfig } from './auth/azureConfig/auth-prod-config';
import { msalQAConfig } from './auth/azureConfig/auth-qa-config';
import { MessageService } from 'primeng/api';

export function MSALInstanceFactory(): IPublicClientApplication {
  const currentHost = window.location.hostname;
  if (currentHost && currentHost == 'localhost') {
    console.log('local')
    return new PublicClientApplication(msalConfig);
  } else if (currentHost && currentHost == 'appsimdev001.azurewebsites.net') {
    console.log('dev')
    return new PublicClientApplication(msalEnvConfig);
  } else if (currentHost && currentHost == 'appsimqa001.azurewebsites.net') {
    console.log('qa')
    return new PublicClientApplication(msalQAConfig);
  } else if (currentHost && currentHost == 'sim.pstechnology.com') {
    console.log('prod')
    return new PublicClientApplication(msalProdConfig);;
  } else {
    console.log('else')
    return new PublicClientApplication(msalConfig);
  }
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
  };
}

@NgModule({
  declarations: [AppComponent, ConfirmationDialogComponent, SessionTimeoutModalComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbThemeModule.forRoot({ name: 'default' }),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    NbCardModule,
    NbInputModule,
    NbFormFieldModule,
    NbButtonModule,
    NbIconModule,
    NbEvaIconsModule,
    MsalModule,
    
  ],
  providers: [
    BnNgIdleService,
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    LocalStorageService,
    SessionTokenTimeoutService,
    SessionTimerInitializer,
    MessageService,
    {
      provide: APP_INITIALIZER,
      useFactory: (sessionTimerInitializer: SessionTimerInitializer) => () => sessionTimerInitializer.initializeApp(),
      multi: true,
      deps: [SessionTimerInitializer]
    }
  ],
  //entryComponents: [LoginComponent],
  // providers: [BnNgIdleService],
  exports: [ReactiveFormsModule, FormsModule],
  bootstrap: [AppComponent],
})
export class AppModule {}
